export default __webpack_public_path__ + "static/media/usa.21a491e8.png";